import React, { useState } from 'react';
import { useParams } from 'react-router-dom';  // To get the reset token from the URL
import { resetPassword } from '../services/authService'; // Import resetPassword function

const PasswordResetPage = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const { token } = useParams(); // Get the token from the URL params

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if both passwords match
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setMessage('');
      return;
    }

    try {
      // Call the resetPassword function and pass the token and newPassword
      const response = await resetPassword(token, newPassword);
      setMessage(response);  // Show success message
      setError('');
    } catch (err) {
      setError('Error resetting password');
      setMessage('');
    }
  };

  return (
    <div>
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>New Password:</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Confirm Password:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Reset Password</button>
      </form>
      {message && <p>{message}</p>}
      {error && <p>{error}</p>}
    </div>
  );
};

export default PasswordResetPage;
